import Vue from "vue";
import Vuex from "vuex";
import { getQuery, axios, webSocket, serverApi, interceptGet } from "@/common";
import clubPage from "./clubPage";
import eSportPage from "./eSportPage";

Vue.use(Vuex);
function copy(obj) {
  return JSON.parse(JSON.stringify(obj));
}
export default new Vuex.Store({
  modules: {
    clubPage,
    eSportPage,
  },
  state: {
    lang: "en",
    _videoListObj: {
      banners: [],
      collections: [],
      tabList: [],
      tabID: "",
      searchList: [],
      searching: false,
    },
    _liveCenterObj: {
      liveBroadcastList: [],
      tornamentList: [],
    },
    _feedbackObj: {
      feedbackTagList: [],
      watchingVideoID: null,
    },
    userData: {
      //旧的用户信息（2019年的版本）
      uid: "",
      token: "",
      avatar: "",
      userName: "",
      sign_ts: 0,
      money: 0,
      watch_progress: 0,
    },
    goingTime: -1,
    inTime: new Date().getTime(),
    hasAutoGetUserdata: -1,
    //=============竞猜 2021-3-15==>
    gambleObject: {
      noCurGame: false,
      gameId: undefined,
      userInfo: null,
      taskList: [],
      competitionList: [],

      //-------------
      activeCompetitionId: undefined,
      activeCompetitionQuestionList: [],
      teamObj: {
        teamList: [],
        videoId: "",
        title: "",
      },
    },
    //<=============竞猜 2021-3-15==
  },
  getters: {
    nowTs(state) {
      return state.inTime + state.goingTime;
    },
    VideoListObj(state, getters) {
      let _videoListObj = copy(state._videoListObj);
      _videoListObj.collections.map((c) => {
        c.nameObj = c.name;
        c.name = c.nameObj[state.lang];
      });
      _videoListObj.tabList.map((list) => {
        list.nameObj = list.name;
        list.name = list.nameObj[state.lang];
        return list;
      });
      return _videoListObj;
    },
    gambleGameId(state) {
      return state.gambleObject.gameId;
    },
    gambleNoCurGame(state) {
      return state.gambleObject.noCurGame;
    },
    gambleUserInfo(state) {
      return state.gambleObject.userInfo || {};
    },
    gambleTaskList(state) {
      return state.gambleObject.taskList || [];
    },
    gambleCompetitionList(state) {
      return state.gambleObject.competitionList || [];
    },
    gambleCurCompetition(state) {
      return (
        state.gambleObject.competitionList.find((item) => item._current) || null
      );
    },
    gambleActiveCompetition(state) {
      return (
        state.gambleObject.competitionList.find(
          (item) => item.cid == state.gambleObject.activeCompetitionId
        ) || []
      );
    },
    gambleActiveCompetitionQuestionList(state, getters) {
      if (!getters.gambleActiveCompetition) {
        return [];
      }
      return state.gambleObject.activeCompetitionQuestionList;
    },
  },
  mutations: {
    runTime(state) {
      if (state.goingTime >= 0) {
        return;
      }
      state.goingTime = 0;
      setInterval(() => {
        state.goingTime += 500;
      }, 500);
    },
    setHasAutoGetUserdata(state, num) {
      this.hasAutoGetUserdata = num;
    },
    setUserData(state, userData) {
      for (let key in userData) {
        state.userData[key] = userData[key];
      }
    },
    setLang(state, lang) {
      state.lang = lang;
    },
    updataVideoListObj(
      state,
      { banners, collections, tabList, tabID, searchList }
    ) {
      if (banners) {
        state._videoListObj.banners = banners;
      }
      if (collections) {
        state._videoListObj.collections = collections;
      }
      if (tabList) {
        state._videoListObj.tabList = tabList;
      }
      if (tabID) {
        state._videoListObj.tabID = tabID;
      }
      if (searchList) {
        state._videoListObj.searching = !searchList.length;
        state._videoListObj.searchList = searchList;
      }
    },
    pushSearchList(state, list) {
      if (list) {
        state._videoListObj.searching = !list.length;
        state._videoListObj.searchList.push(...list);
      }
    },
    updataLiveCenterObj(state, { liveBroadcastList, tornamentList }) {
      if (liveBroadcastList) {
        state._liveCenterObj.liveBroadcastList = liveBroadcastList;
      }
      if (tornamentList) {
        state._liveCenterObj.tornamentList = tornamentList;
      }
    },
    updataFeedbackObj(state, { feedbackTagList }) {
      if (feedbackTagList) {
        state._feedbackObj.feedbackTagList = feedbackTagList;
      }
    },
    setWatchingVideoID(state, id) {
      state._feedbackObj.watchingVideoID = id;
    },
    //=============竞猜 2021-3-15==>
    gambleSetCurrentGameId(state, id) {
      state.gambleObject.gameId = id;
    },
    gambleSetNoCurrentGameId(state) {
      state.gambleObject.noCurGame = true;
    },
    gambleSetUserInfo(state, userInfo) {
      state.gambleObject.userInfo = userInfo;
    },
    gambleSetTaskList(state, list) {
      state.gambleObject.taskList = list;
    },
    gambleSetCompetitionList(state, list) {
      state.gambleObject.competitionList = list;
    },
    gambleSetActiveCompetitionId(state, cid) {
      state.gambleObject.activeCompetitionId = cid;

      this.dispatch("gambleGetActiveCompetitionQuestionList");
      this.dispatch("gambleGetTeamList");
    },
    gambleSetActiveCompetitionQuestionList(state, list) {
      state.gambleObject.activeCompetitionQuestionList = list;
    },
    gambleSetTeamInfo(state, { list, videoId, title }) {
      if (list !== undefined) {
        state.gambleObject.teamObj.teamList = list;
      }
      if (videoId !== undefined) {
        state.gambleObject.teamObj.videoId = videoId;
      }
      if (title !== undefined) {
        state.gambleObject.teamObj.title = title;
      }
    },
    gambleSetUpdateQuestion(state, question) {
      state.gambleObject.activeCompetitionQuestionList = state.gambleObject.activeCompetitionQuestionList.map(
        (item) => {
          if (item.qid == question.qid) {
            return question;
          } else {
            return item;
          }
        }
      );
    },
    //<=============竞猜 2021-3-15==
  },
  actions: {
    async getBaseInfo({ commit, state }) {
      /*
      http://localhost:7050/api/basic?uid=Wgm3N%5C%2FwR%2BZTozWiR&hostId=10001&token=9913d84f35ec43c285d657c707a1ab7fb720f03ef34ff356fc1c27cce8ec2fe07294f11d25d6f784&lang=zht
      */
      /*
      新
      https://live.knivesout.jp/?hostid=10001&uid=1401512293&token=9913d84f35ec43c285d657c707a1ab7fb720f03ef34ff356fc1c27cce8ec2fe07294f11d25d6f784&
      */
      /*
      hostid=10001&uid=1401512293&token=9913d84f35ec43c285d657c707a1ab7fb720f03ef34ff356fc1c27cce8ec2fe07294f11d25d6f784&lang=zht
      */
      let uid = +getQuery("uid") || -1;
      let token = getQuery("token");
      let hostid = +getQuery("hostid") || 0;
      let result = await axios.get(
        `/api/basic?uid=${uid}&token=${token}&hostId=${hostid}&lang=${
          state.lang
        }`
      );
      console.log(result);
      if (result.status == 200) {
        if (result.data) {
          let data = result.data;
          if (data.feedbackTagList) {
            commit("updataFeedbackObj", {
              feedbackTagList: data.feedbackTagList,
            });
          }
          if (data.user.username) {
            let loginData = await webSocket.get("/login", {
              encode_id: uid,
              server: hostid,
              token,
            });
            commit("setUserData", {
              uid: uid,
              userName: data.user.username,
              token,
              avatar: data.user.avatar,
              sign_ts: loginData.sign_ts || 0,
              money: loginData.money || 0,
              watch_progress: loginData.watch_progress,
            });
          }
        }
      }
    },
    async getUserData({ commit, state }) {
      let loginData = await webSocket.get("/user/info/find", {});
      commit("setUserData", {
        sign_ts: loginData.sign_ts || 0,
        money: loginData.money || 0,
        watch_progress: loginData.watch_progress,
      });
    },
    autoGetUserDate({ commit, state, dispatch }) {
      if (state.hasAutoGetUserdata >= 0) {
        return;
      }
      let num = setInterval(() => {
        dispatch("getUserData");
      }, 60 * 1000);
      commit("setHasAutoGetUserdata", num);
    },
    async getLiveBroadcastList({ commit, state }) {
      /*
      http://localhost:7050/api/liveBroadcastList
      http://localhost:7050/api/liveBroadcast/Urv18qocceo
      */
      let result = await axios.get(`/api/liveBroadcastList?size=100`);
      console.log(result);
      if (result.status == 200) {
        if (result.data) {
          let data = result.data;
          if (data.list) {
            commit("updataLiveCenterObj", {
              liveBroadcastList: data.list,
            });
          }
        }
      }
    },
    async getTornamentList({ commit, state }) {
      let result = await axios.get(`/api/tornamentList`);
      console.log(result);
      if (result.status == 200) {
        if (result.data) {
          let data = result.data;
          if (data.videos) {
            commit("updataLiveCenterObj", {
              tornamentList: data.videos,
            });
          }
        }
      }
    },
    // async getVideoTabList({commit, state}){
    //   let result = await axios.get(`/api/videoTabList`)
    //   console.log(result);
    //   if(result.status == 200){
    //     if(result.data){
    //       let data = result.data;
    //       if(data.list){
    //         commit('updataVideoListObj',{
    //           tabList:data.list,
    //           ...data.firstTab,
    //           tabID:data.firstTab.id
    //         })
    //       }
    //     }
    //   }

    // },//================
    async getVideoTabList({ commit, state }) {
      let result = await axios.get(`/api/videoTabList`);
      console.log(result);
      if (result.status == 200) {
        if (result.data) {
          let data = result.data;
          if (data.list) {
            commit("updataVideoListObj", {
              tabList: data.list,
              ...data.firstTab,
              tabID: data.firstTab.id,
            });
          }
        }
      }
    },
    async getVideoList({ commit, state }, id) {
      commit("updataVideoListObj", {
        banners: [],
        collections: [],
      });
      let result = await interceptGet(`/api/videoTab/${id}`);
      if (result.status == 200) {
        if (result.data) {
          let data = result.data;
          let { banners, collections } = data;

          commit("updataVideoListObj", {
            banners,
            collections,
            tabID: data.id,
          });
        }
      }
    },
    async searchVideo({ commit, state }, keyword) {
      commit("updataVideoListObj", {
        searchList: [],
      });
      let result = await axios.get(
        `/api/videoList?page=0&size=20&keyword=${keyword}`
      );
      if (result.status == 200) {
        if (result.data) {
          let data = result.data;
          let { list } = data;

          commit("updataVideoListObj", {
            searchList: list,
          });
        }
      }
    },
    async searchMoreVideo({ commit, state }, keyword) {
      // commit('updataVideoListObj',{
      //   searchList:[]
      // })
      if (state._videoListObj.searching) {
        return;
      }
      commit("pushSearchList", []);
      let result = await axios.get(
        `/api/videoList?page=${Math.ceil(
          state._videoListObj.searchList.length / 20
        )}&size=20&keyword=${keyword}`
      );
      if (result.status == 200) {
        if (result.data) {
          let data = result.data;
          let { list } = data;

          commit("pushSearchList", list);
        }
      }
    },
    //=============竞猜 2021-3-15==>
    async gambleGetCurrentGameId({ commit, dispatch, state }) {
      try {
        let res = await serverApi.get("current_game");
        if (res.code == 200 && res.data && res.data.gid !== undefined) {
          // this.gameId = res.data.gid;
          commit("gambleSetCurrentGameId", res.data.gid);
          dispatch("gambleGetCompetitionList");
        } else {
          commit("gambleSetNoCurrentGameId");
        }
      } catch (e) {
        commit("gambleSetNoCurrentGameId");
      }
    },
    async gambleGetUserInfo({ commit, state }) {
      let res = await serverApi.get("user");
      if (res.code == 200 && res.data) {
        // this._userInfo = res.data;
        if (res.data.icon) {
          //游戏会传http的图片，造成加载不了，所以这里替换一下
          res.data.icon = res.data.icon.replace(/^http:/, "");
        }
        commit("gambleSetUserInfo", res.data);
      }
    },
    async gambleGetTaskList({ commit, state }) {
      let res = await serverApi.get("task");
      if (res.code == 200 && res.data) {
        // this._userInfo = res.data;
        commit("gambleSetTaskList", res.data);
      }
    },
    async gambleGetCompetitionList({ commit, state }) {
      commit("gambleSetCompetitionList", []);
      if (
        !state.gambleObject.gameId &&
        ![0, "0"].includes(state.gambleObject.gameId)
      ) {
        return;
      }
      let res = await serverApi.get("competitions", {
        gid: state.gambleObject.gameId,
        // cursor:0,
        // limit:20,
      });
      if (res.code == 200 && res.data) {
        // this._userInfo = res.data;
        if (res.data.data && res.data.data.length) {
          commit(
            "gambleSetCompetitionList",
            res.data.data.map((item) => ({
              ...item,
              _current: item.cid == res.data.current_competition.cid,
            }))
          );
        }
      }
    },
    async gambleGetActiveCompetitionQuestionList({ commit, state, getters }) {
      commit("gambleSetActiveCompetitionQuestionList", []);
      if (!getters.gambleActiveCompetition) {
        return;
      }
      let list = [];
      for (let qid of getters.gambleActiveCompetition.qids || []) {
        let res = await serverApi.get("question", {
          qid,
        });
        if (res.code == 200 && res.data) {
          list.push(res.data);
          // this._userInfo = res.data;
          // if(res.data.data && res.data.data.length){
          //   commit('gambleSetCompetitionList',res.data.data.map(item=>({
          //     ...item,
          //     _current:item.cid == res.data.current_competition.cid,
          //   })))
          // }
        }
      }
      commit("gambleSetActiveCompetitionQuestionList", list);
    },
    async gambleGetTeamList({ commit, state, getters }) {
      commit("gambleSetTeamInfo", { list: [], videoId: "", title: "" });
      if (!getters.gambleActiveCompetition) {
        return;
      }

      let res = await serverApi.get("team_v2", {
        cid: getters.gambleActiveCompetition.cid,
      });
      if (res.code == 200) {
        commit("gambleSetTeamInfo", {
          list: res.data.teams,
          videoId: res.data.live_url,
          title: res.data.team_desc,
        });
      }
    },
    async gambleGetupdateQuestion({ commit, state, getters }, qid) {
      let res = await serverApi.get("question", {
        qid,
      });
      if (res.code == 200 && res.data) {
        commit("gambleSetUpdateQuestion", res.data);
      }
    },
    //<=============竞猜 2021-3-15==
  },
});

/*

*/
